import ContactProfileModuleConfig from "./ContactProfileModuleConfig";
import {ContactsFilterController} from "./controller/filter/contacts-filter";
import {BorrowerWidget} from "./controller/widget/borrowerWidget";
import {CustomerWidget} from "./controller/widget/wrapper/customer/customer_widget";
import {LeadWidget} from "./controller/widget/wrapper/lead/lead_widget";
import {PartnerWidget} from "./controller/widget/wrapper/partner/partner_widget";

ContactProfileModuleConfig.createNewModule()
    .component('contactsFilter', ContactsFilterController.instance)
    .component('borrowerWidget', BorrowerWidget.instance)
    .component('customerWidget', CustomerWidget.instance)
    .component('leadWidget', LeadWidget.instance)
    .component('partnerWidget', PartnerWidget.instance);